export default function getLabelValue(inputElement: HTMLInputElement): string | undefined {
    const parent = inputElement.parentElement;
    if (parent != null) {
        const labels = parent.getElementsByTagName('label');
        const firstLabel = Array.from(labels).find(() => true);

        if (firstLabel && firstLabel.textContent != null) {
            return firstLabel.textContent;
        }
    }
    return undefined;
}
